import axios from "axios";
import jwtDecode from "jwt-decode";
import pDebounce from "p-debounce";
import localStorage from "src/utils/localStorage";
import {
  ACCESS_TOKEN,
  REFRESH_TOKEN,
  RENEW_WINDOW_TIME,
} from "src/variable/constant";
import { authFailedHomeUrl } from "src/utils/helper";

let accessToken = localStorage.getItem(ACCESS_TOKEN);
let authFailedHandled = false;

function handleAuthFailed() {
  if (authFailedHandled) return;
  authFailedHandled = true;
  const target = authFailedHomeUrl();
  try {
    window.top.location.href = target;
  } catch (_) {
    window.location.href = target;
  }
}

function shouldRefreshToken(token) {
  try {
    const decodedToken = jwtDecode(token);

    if (decodedToken.exp * 1000 - new Date().valueOf() < RENEW_WINDOW_TIME) {
      return true;
    }

    return false;
  } catch (ex) {
    return true;
  }
}

const refreshAccessToken = pDebounce.promise(
  async function () {
    try {
      const json = await axios.post(
        "/finan-user/api/v1/auth/renew-token",
        {
          refresh_token: localStorage.getItem(REFRESH_TOKEN),
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return json.data.data.token;
    } catch (err) {
      // Refresh fail (refresh_token rỗng/hết hạn): trả parent về home kèm
      // ?auth_code=failed để shop tự xử lý.
      handleAuthFailed();
      throw err;
    }
  },
  { maxAge: 60000 }
);

export async function getAccessToken() {
  if (!accessToken || shouldRefreshToken(accessToken)) {
    accessToken = await refreshAccessToken();
  }

  return accessToken;
}
